module.exports = __webpack_public_path__ + "img/img_ranking3.aafe6eb1.png";